import * as React from 'react'

import { observer } from 'mobx-react'

import { Panes } from 'modules/core/components/Panes'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import WorkScheduleTabs from 'modules/work_schedules/components/Tabs'
import type DayConfiguration from 'modules/work_schedules/store/models/DayConfiguration'
import type OverlapPeriod from 'modules/work_schedules/store/models/OverlapPeriod'
import type WorkSchedule from 'modules/work_schedules/store/models/Schedule'

import EditWorkScheduleSection from './EditWorkScheduleSection'
import PeriodSection from './PeriodSection'

export interface Props {
  workSchedule: WorkSchedule
  overlapPeriods: OverlapPeriod[]
  dayConfigurations: DayConfiguration[]
  periodLoading: boolean
  defaultPeriod: OverlapPeriod | undefined
  canAssignEmployees: boolean
  canReassignAll: boolean
  canAddBreaks: boolean
}

const WorkScheduleSettings = ({
  workSchedule,
  overlapPeriods,
  defaultPeriod,
  dayConfigurations,
  periodLoading,
  children,
  canAssignEmployees,
  canReassignAll,
  canAddBreaks,
}: React.PropsWithChildren<Props>) => {
  const dayConfigurationsByPeriod = defaultPeriod
    ? dayConfigurations.filter(
        (dayConfiguration) =>
          dayConfiguration.attributes.overlap_period_id === defaultPeriod.attributes.id
      )
    : undefined

  return (
    <ResponsivePage.Body showHeader={false} variant="wide" loading={periodLoading} error={null}>
      <WorkScheduleTabs canAssignEmployees={canAssignEmployees} />

      <Panes direction="vertical">
        {workSchedule && defaultPeriod && dayConfigurationsByPeriod ? (
          <EditWorkScheduleSection
            workSchedule={workSchedule}
            defaultPeriod={defaultPeriod}
            dayConfigurations={dayConfigurationsByPeriod}
            canAssignEmployees={canAssignEmployees}
            canReassignAll={canReassignAll}
            canAddBreaks={canAddBreaks}
          />
        ) : null}
        <PeriodSection id={workSchedule.id} overlapPeriods={overlapPeriods} />
        {children}
      </Panes>
    </ResponsivePage.Body>
  )
}

export default observer(WorkScheduleSettings)
